import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import Services from '../components/Services';
import About from '../components/About';
import Praktisk from '../components/Praktisk';
import Contact from '../components/Contact';
import Testimonials from '../components/Testimonials';

const Home = () => {
  return (
    <main className="bg-stone-50">
      <Helmet>
        <title>Massage og massageterapi Nørrebro</title>
        <meta name="description" content="Massage og massageterapi på Nørrebro, København v/ RAB-registreret massageterapeut Trine Agerbo. Behandling, forebyggelse og smertelindring." />
        <meta property="og:title" content="Massage og massageterapi Nørrebro" />
        <meta property="og:description" content="Massage og massageterapi på Nørrebro, København v/ RAB-registreret massageterapeut Trine Agerbo. Behandling, forebyggelse og smertelindring." />
        <meta property="og:image" content="" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Massage og massageterapi Nørrebro" />
        <meta name="twitter:description" content="Massage og massageterapi på Nørrebro, København v/ RAB-registreret massageterapeut Trine Agerbo. Behandling, forebyggelse og smertelindring." />
        <meta name="twitter:image" content="" />
      </Helmet>
      <Hero />
      <Services />
      <About />
      <Testimonials />
      <Praktisk />
      <Contact />
    </main>
  );
};

export default Home;
